import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaMoneyBillWave } from "react-icons/fa";
import {
  FaUserTie,
  FaUsers,
  FaCogs,
  FaToolbox,
  FaMoon,
  FaSun,
  FaClipboardList,
  FaCodeBranch,
  FaShieldAlt,
  FaTachometerAlt,
  FaClipboard,
  FaStore,
  FaArrowUp,
  FaArrowDown,
  FaShoppingCart,
  FaCar,
} from "react-icons/fa";
import GlobalContext from "../connections/GlobalContext";
import axios from "axios";
import swal from "sweetalert";

import Logo from "../image/logo.jpg";

const Navbar = ({ setTheme, theme }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [info, setInfo] = useState(false);
  const [countdown, setCountdown] = useState(60);

  const [view, setView] = useState(false);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { globalValue } = useContext(GlobalContext);
  const [isInactive, setIsInactive] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    setTheme(savedTheme);
    document.documentElement.classList.toggle("dark", savedTheme === "dark");
    branch_details(sessionStorage.getItem("name"));
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.documentElement.classList.toggle("dark", newTheme === "dark");
  };

  const branch_details = async (id) => {
    try {
      const response = await axios.post(
        `${globalValue}/branch_details`,
        { id },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );

      setBranches(response.data);
      console.log("Stored branch:", sessionStorage.getItem("branch"));
      console.log("Branch data:", branches);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  const navigate = useNavigate();

  const handleBranchSelect = (branchId) => {
    setLoading(true);
    setTimeout(() => {
      sessionStorage.setItem("branch", branchId);
      setLoading(false);
      setView(false);

      navigate("/dashboard");
    }, 2000);
  };

  const links = [
    {
      to: "/spare_request",
      icon: <FaToolbox className="text-purple-800" />,
      label: "Spare Request",
    },
    {
      to: "/customer",
      icon: <FaUsers className="text-purple-800" />,
      label: "Customer",
    },

    {
      to: "/purchase",
      icon: <FaClipboard className="text-purple-800" />,
      label: "Purchase",
    },
    {
      to: "/sales",
      icon: <FaShoppingCart className="text-purple-800" />,
      label: "Sales",
    },
    {
      to: "/advance",
      icon: <FaShoppingCart className="text-purple-800" />,
      label: "Advance",
    },
    {
      to: "/expense",
      icon: <FaMoneyBillWave className="text-purple-800" />,
      label: "Expense",
    },
    {
      to: "/income",
      icon: <FaMoneyBillWave className="text-purple-800" />,
      label: "Income",
    },
    {
      to: "/payment",
      icon: <FaMoneyBillWave className="text-purple-800" />,
      label: "Payment",
    },
    {
      to: "/spare/log",
      icon: <FaToolbox className="text-purple-800" />,
      label: "Spare Log",
    },
    {
      to: "/spare_log_admin",
      icon: <FaToolbox className="text-purple-800" />,
      label: "Spare Log",
    },
    {
      to: "/estimate_data",
      icon: <FaClipboardList className="text-purple-800" />,
      label: "Estimate Log",
    },
    {
      to: "/service_log",
      icon: <FaCogs className="text-purple-800" />,
      label: "Service Log",
    },
    {
      to: "/report",
      icon: <FaCogs className="text-purple-800" />,
      label: "Report",
    },
  ];

  const masterLinks = [
    {
      to: "/staffrole",
      icon: <FaUserTie className="text-purple-800" />,
      label: "Staff Role",
    },
    {
      to: "/staff",
      icon: <FaUserTie className="text-purple-800" />,
      label: "Staff",
    },
    {
      to: "/vendor",
      icon: <FaStore className="text-purple-800" />,
      label: "Vendor",
    },
    {
      to: "/spares",
      icon: <FaToolbox className="text-purple-800" />,
      label: "Spares",
    },
    {
      to: "/services",
      icon: <FaCogs className="text-purple-800" />,
      label: "Services",
    },
    {
      to: "/branch",
      icon: <FaCodeBranch className="text-purple-800" />,
      label: "Branch",
    },
    {
      to: "/insurance",
      icon: <FaShieldAlt className="text-purple-800" />,
      label: "Insurance",
    },
    {
      to: "/brand",
      icon: <FaCar className="text-purple-800" />,
      label: "Brands and Models",
    },
    {
      to: "/expense_category",
      icon: <FaMoneyBillWave className="text-purple-800" />,
      label: "Expense Category",
    },
    {
      to: "/income_category",
      icon: <FaMoneyBillWave className="text-purple-800" />,
      label: "Income Category",
    },
    {
      to: "/insurance_type",
      icon: <FaShieldAlt className="text-purple-800" />,
      label: "Insurance Type",
    },
  ];

  const position = sessionStorage.getItem("position");

  let filteredLinks, filteredmaster_links;

  if (position === "superadmin") {
    filteredLinks = links.filter((link) =>
      [
        "/dashboard",
        "/spare_log_admin",
        "/staff",
        "/staffrole",
        "/customer",
        "/job_card",
        "/brand",
        "/payment",
        "/expense",
        "/income",
        "/report",
        "/spares",
        "/purchase",
        "/services",
        "/spare_request",
        "/expense",
        "/sales",
        "/advance",
        "branch",
        "insurance",
        "/estimate_data",
        "/service_log",
        "/vendor",
      ].includes(link.to)
    );
    filteredmaster_links = masterLinks;
  } else if (position === "admin") {
    filteredLinks = links.filter((link) =>
      [
        "/staff",
        "/customer",
        "/job_card",
        "/spares",
        "/report",
        "/services",
        "/income",
        "/payment",
        "/brand",
        "/expense",
        "/spare_request",
        "/purchase",
        "/spare_log_admin",
        "/sales",
        "/advance",
        "/estimate_data",
        "/service_log",
        "/vendor",
      ].includes(link.to)
    );
    filteredmaster_links = masterLinks.filter((link) =>
      [
        "/staff",
        "/customer",
        "/job_card",
        "/spares",
        "/services",
        "/brand",
        "/expense_category",
        "/income_category",
        "/spare_request",
        "/spare_log_admin",
        "/sales",
        "/estimate_data",
        "/service_log",
        "/vendor",
      ].includes(link.to)
    );
  } else if (position === "staff") {
    filteredLinks = links.filter((link) =>
      ["/estimate_data", "/service_log", "/spare/log"].includes(link.to)
    );
    filteredmaster_links = masterLinks.filter((link) =>
      ["/estimate_data", "/service_log", "/spare/log"].includes(link.to)
    );
  } else {
    filteredLinks = [];
  }

  const [master, setMaster] = useState(false);
  useEffect(() => {
    if (isInactive) {
      sessionStorage.clear();
      navigate("/");
    }
  }, [isInactive]);

  const changeToken = async () => {
    if (true) {
      try {
        const response = await axios.post(`${globalValue}/ctoken`, {
          username: sessionStorage.getItem("staff"),
        });
        sessionStorage.setItem("token", response.data.token);
        console.log("Token refreshed:", response.data.token);
      } catch (error) {
        console.error("Error refreshing token:", error);
      }
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      changeToken();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!sessionStorage.getItem("token")) {
      navigate("/");
    }
  }, [sessionStorage.getItem("token")]);

  const handleLogout = () => {
    sessionStorage.removeItem("authToken");
    sessionStorage.clear();
    navigate("/");
  };

  return (
    <>
      <header
        className={`fixed top-0 w-full border-b z-50 ${
          theme === "dark"
            ? "bg-gray-800 text-gray-100 border-gray-700"
            : "bg-gray-100 text-gray-900"
        }`}
      >
        <div className="px-4 py-3 flex justify-between items-center  relative">
          <div className="flex items-center gap-4">
            <button
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              className="p-2 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 md:hidden"
            >
              <span className="sr-only">Open sidebar</span>
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                  clipRule="evenodd"
                />
              </svg>
            </button>

            {/* <div className="flex flex-col">
              <span className="text-xl font-semibold text-purple-800">
                JALS
              </span>
              <p className="hidden md:block text-[10px]">Auto Mobiles</p>
            </div> */}
          </div>

          <div></div>
          <div className="flex items-center gap-4">
            <FaCodeBranch className="hidden md:block text-purple-800" />
            <p className="hidden md:block ">
              {branches.find(
                (data) => data["branch_id"] === sessionStorage.getItem("branch")
              )?.branch_name || "Branch not found"}
            </p>
            <button
              onClick={toggleTheme}
              className="p-2 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700"
            >
              {theme === "light" ? <FaMoon size={18} /> : <FaSun size={18} />}
            </button>

            <div className="relative">
              <button
                onClick={() => setInfo(!info)}
                className="flex items-center bg-gray-800 dark:bg-gray-600 rounded-full p-1 focus:ring-2 focus:ring-gray-300"
              >
                <img
                  className="w-8 h-8 rounded-full"
                  src="https://randomuser.me/api/portraits/men/32.jpg"
                  alt="User"
                />
              </button>
              {info && (
                <div className="absolute right-0 top-10 bg-white dark:bg-gray-900 border dark:border-gray-700 rounded-md shadow-lg w-48">
                  <div className="p-4">
                    <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
                      {sessionStorage.getItem("name")}
                    </p>
                  </div>
                  <ul className="py-1">
                    <li onClick={() => setInfo(false)}>
                      <Link
                        to="/dashboard"
                        className="block px-4 py-2 text-sm text-gray-900 dark:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-700"
                      >
                        Dashboard
                      </Link>
                    </li>
                    <li onClick={() => setInfo(false)}>
                      <Link
                        onClick={() => handleLogout()}
                        className="block px-4 py-2 text-sm text-gray-900 dark:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-700"
                      >
                        Sign out
                      </Link>
                    </li>
                    <li onClick={() => setInfo(false)}>
                      <p className="block px-4 py-2 text-sm text-gray-900 dark:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-700">
                        {branches.find(
                          (data) =>
                            data["branch_id"] ===
                            sessionStorage.getItem("branch")
                        )?.branch_name || "Branch not found"}
                      </p>
                    </li>

                    <li onClick={() => setInfo(false)}>
                      <p
                        className="block px-4 py-2 text-sm text-gray-900 dark:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer"
                        onClick={() => {
                          branch_details(sessionStorage.getItem("name"));
                          setView(true);
                        }}
                      >
                        <span className="text-green-600 dark:text-green-400">
                          Switch Branch
                        </span>
                      </p>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
          <img alt="JALS" src={Logo} className="absolute left-14 md-left-2 w-24 h-20 "></img>
        </div>
      </header>

      <div
        className={`fixed top-[70px] left-0 h-full shadow-lg  transition-transform duration-300 z-40 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0 w-[200px] md:w-[250px] ${
          theme === "dark"
            ? "bg-gray-800 text-gray-100"
            : "bg-gray-50 text-gray-900"
        }`}
      >
        <nav className="p-4 h-[90vh] overflow-y-auto">
          <ul className="flex flex-col gap-4 overflow-auto scrollbar-transparent">
            {sessionStorage.getItem("position") === "superadmin" ? (
              <>
                {" "}
                <li>
                  <Link
                    to="/dashboard"
                    className={`flex items-center gap-2 p-2 rounded-lg ${
                      location.pathname === "/dashboard"
                        ? theme === "dark"
                          ? "bg-gray-700 text-gray-100"
                          : "bg-gray-300 text-gray-900"
                        : theme === "dark"
                        ? "hover:bg-gray-600 text-gray-100"
                        : "hover:bg-gray-200 text-gray-900"
                    }`}
                    onClick={() => setIsSidebarOpen(false)}
                  >
                    <FaTachometerAlt className="text-purple-800" />
                    <span>Dashboard</span>
                  </Link>
                </li>
              </>
            ) : null}
            {sessionStorage.getItem("position") !== "staff" ? (
              <>
                <hr />
                <li>
                  <Link
                    onClick={() => {
                      setMaster(!master);
                    }}
                    className={`flex items-center gap-2 p-2 rounded-lg ${
                      location.pathname === "decec"
                        ? theme === "dark"
                          ? "bg-gray-700 text-gray-100"
                          : "bg-gray-300 text-gray-900"
                        : theme === "dark"
                        ? "hover:bg-gray-600 text-gray-100"
                        : "hover:bg-gray-200 text-gray-900"
                    }`}
                  >
                    <span>Master</span>

                    {master ? (
                      <FaArrowUp className="ml-auto text-purple-800" />
                    ) : (
                      <FaArrowDown className="ml-auto text-purple-800" />
                    )}
                  </Link>
                </li>

                {master && (
                  <div className="ms-2">
                    {filteredmaster_links.map(({ to, icon, label }) => (
                      <li key={to}>
                        <Link
                          to={to}
                          onClick={() => setIsSidebarOpen(false)}
                          className={`flex items-center gap-2 p-2 mb-2 rounded-lg ${
                            location.pathname === to
                              ? theme === "dark"
                                ? "bg-gray-700 text-gray-100"
                                : "bg-gray-300 text-gray-900"
                              : theme === "dark"
                              ? "hover:bg-gray-600 text-gray-100"
                              : "hover:bg-gray-200 text-gray-900"
                          }`}
                        >
                          {icon}
                          <span>{label}</span>
                        </Link>
                      </li>
                    ))}
                  </div>
                )}
                <hr />
              </>
            ) : null}

            {filteredLinks.map(({ to, icon, label }) => (
              <li key={to}>
                <Link
                  to={to}
                  onClick={() => setIsSidebarOpen(false)}
                  className={`flex items-center gap-2 p-2 rounded-lg ${
                    location.pathname === to
                      ? theme === "dark"
                        ? "bg-gray-700 text-gray-100"
                        : "bg-gray-300 text-gray-900"
                      : theme === "dark"
                      ? "hover:bg-gray-600 text-gray-100"
                      : "hover:bg-gray-200 text-gray-900"
                  }`}
                >
                  {icon}
                  <span>{label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      {view && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-3/4 max-w-3xl">
            <h2 className="text-lg font-semibold mb-4 text-center text-gray-900 dark:text-gray-100">
              Available Branches
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {branches.map((branch, index) => (
                <div
                  key={index}
                  className={`p-4 border dark:border-gray-700 rounded-lg ${
                    sessionStorage.getItem("branch") === branch.branch_id
                      ? "border-2 border-gray-500"
                      : null
                  } bg-gray-100 dark:bg-gray-700 text-center cursor-pointer text-gray-900 dark:text-gray-100`}
                  onClick={() => {
                    if (sessionStorage.getItem("branch") !== branch.branch_id) {
                      handleBranchSelect(branch.branch_id);
                    }
                  }}
                >
                  {branch.branch_name}
                </div>
              ))}
            </div>
            <button
              onClick={() => setView(false)}
              className="mt-6 px-4 py-2 bg-purple-800 text-white rounded-md hover:bg-purple-900"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {loading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="w-16 h-16 border-4 border-purple-800 border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
    </>
  );
};

export default Navbar;
